import React, { useContext, useState } from 'react';
import { Script } from 'gatsby';
import { Header, Footer, Consult, SignUpModal } from '../components';
import { GlobalSiteDataContext } from '../context';
import { hardTrim, CYBER_WEEK_COUNTDOWN_END_DATE } from '../utils';
import '../utils/styles/global.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

export function Layout({ children, location }) {
    const siteData = useContext(GlobalSiteDataContext);
    const [showSignUpModal, setShowSignUpModal] = useState(false);

    const currentDate = new Date();
    const showCountdown = CYBER_WEEK_COUNTDOWN_END_DATE > currentDate;

    return (
        <div
            id={`${location.pathname === '/' ? 'home' : hardTrim(location.pathname)}-page-wrapper`}
            className={showCountdown ? 'with-countdown' : ''}
        >
            <Header siteData={siteData} showCountdown={showCountdown} />
            {children}
            <span id="consult"></span>
            <Consult siteData={siteData} />
            {showSignUpModal && <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />}
            <Footer siteData={siteData} setShowSignUpModal={setShowSignUpModal} />
            <Script key="cloudamp">
                {`
          window._cloudAmp = window._cloudAmp || {};
          _cloudAmp.forms = [];
          (function () {
            var scripts = document.getElementsByTagName('script'),
                sLen = scripts.length,
                ca_script = document.createElement('script'),
                head = document.getElementsByTagName('head'),
                protocol = document.location.protocol,
                httpsDomain = '1d5ef9e9369608f625a8-878b10192d4a956595449977ade9187d.ssl.cf2.rackcdn.com',
                httpDomain = 'trk.cloudamp.net',
                filename = 'ctk.js',
                srcDomain = protocol === 'http:' ? httpDomain : httpsDomain;
  
            ca_script.type = 'text/javascript';
            ca_script.async = true;
            ca_script.src = protocol + '//' + srcDomain + '/' + filename;
            head[0].appendChild(ca_script);
          })();
        `}
            </Script>
        </div>
    );
}

export default Layout;
